import {
  Avatar,
  Grid,
  ListItem,
  ListItemAvatar,
  ListItemText,
} from "@material-ui/core";
import { AccountCircle, ListAlt, MonetizationOn } from "@material-ui/icons";
import { memo, useContext, useMemo } from "react";
import { EmissaoContext } from "../../../contexts/EmissaoContext";
import MaskService from "../../../../../../utils/mask/maskService";

const PurchaseFooter = ({ step = 0 }) => {
  const { selectedSupplier, selectedPurchaseNf, selectedPurchaseItems } =
    useContext(EmissaoContext);

  const suplierName = useMemo(
    () => (selectedSupplier[0] ? selectedSupplier[0].apelido : ""),
    [selectedSupplier]
  );
  const selectedNotes = useMemo(
    () =>
      selectedPurchaseNf.length
        ? selectedPurchaseNf.map((nfe, i) =>
            i + 1 === selectedPurchaseNf.length ? nfe.numero : `${nfe.numero}, `
          )
        : "-",
    [selectedPurchaseNf]
  );
  const totalSelectedItems = useMemo(
    () => selectedPurchaseItems?.length || 0,
    [selectedPurchaseItems]
  );

  const totalValueSelectedItems = useMemo(() => {
    const calculatedTotal = (selectedPurchaseItems || []).reduce(
      (accumulator, item) => accumulator + parseFloat(item?.vl_total || "0"),
      0
    );

    return MaskService.toMask(
      "decimal",
      parseFloat(calculatedTotal).toFixed(2)
    );
  }, [selectedPurchaseItems]);

  return (
    <Grid container spacing={1} alignItems="center">
      <Grid item sm justifyContent="center" container>
        <ListItem>
          <ListItemAvatar>
            <Avatar>
              <AccountCircle />
            </Avatar>
          </ListItemAvatar>
          <ListItemText
            primary="Fornecedor Selecionado: "
            secondary={suplierName}
          />
        </ListItem>
      </Grid>
      {step !== 0 && (
        <Grid item sm justifyContent="center" container>
          <ListItem>
            <ListItemAvatar>
              <Avatar>
                <MonetizationOn />
              </Avatar>
            </ListItemAvatar>
            <ListItemText
              primary="Nota(s) Selecionada(s): "
              secondary={selectedNotes}
            />
          </ListItem>
        </Grid>
      )}
      {step > 1 && (
        <>
          <Grid item sm justifyContent="center" container>
            <ListItem>
              <ListItemAvatar>
                <Avatar>
                  <ListAlt />
                </Avatar>
              </ListItemAvatar>
              <ListItemText
                primary="Total de Itens: "
                secondary={totalSelectedItems}
              />
            </ListItem>
          </Grid>
          <Grid item sm justifyContent="center" container>
            <ListItem>
              <ListItemAvatar>
                <Avatar>
                  <ListAlt />
                </Avatar>
              </ListItemAvatar>
              <ListItemText
                primary="Total de Itens R$: "
                secondary={totalValueSelectedItems}
              />
            </ListItem>
          </Grid>
        </>
      )}
    </Grid>
  );
};

export default memo(PurchaseFooter);
